module.exports = __webpack_public_path__ + "img/tj-report-none-2.0712bb26.png";